function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Skeleton, Image, Space, Statistic, Card, Row as AntRow, Col as AntCol, Button, Modal } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "./includes/Common";
import { AwardFill } from "react-bootstrap-icons";
import Vote from "../pages/Vote";
import VoteNow from "./forms/VoteNow";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var ContestCandidatesView = function ContestCandidatesView(_ref) {
  var milestone_id = _ref.milestone_id;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    milestone = _useState2[0],
    setMilestone = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showVote = _useState8[0],
    setShowVote = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedCandidat = _useState10[0],
    setSelectedCandidat = _useState10[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getcontestmilestone/" + milestone_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setMilestone(response.data.milestone);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    style: {
      minHeight: "550px"
    },
    children: [isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx("div", {
      children: milestone && /*#__PURE__*/_jsx(AntRow, {
        gutter: 16,
        children: milestone.contest_milestone_candidates.map(function (c) {
          return /*#__PURE__*/_jsx(AntCol, {
            span: 8,
            children: /*#__PURE__*/_jsxs(Card, {
              hoverable: true,
              style: {
                width: 240,
                marginBottom: "12px"
              },
              cover: /*#__PURE__*/_jsx("img", {
                src: c.cover_url
              }),
              actions: [/*#__PURE__*/_jsx(Button, {
                type: "primary",
                icon: /*#__PURE__*/_jsx(AwardFill, {}),
                onClick: function onClick() {
                  setSelectedCandidat(c);
                  setShowVote(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "Choisir"
                })
              })],
              children: [/*#__PURE__*/_jsx(Meta, {
                title: c.name
              }), /*#__PURE__*/_jsx("div", {})]
            })
          }, c.id);
        })
      })
    }), selectedCandidat && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        footer: null,
        title: /*#__PURE__*/_jsx("b", {
          children: "Parfait !"
        }),
        open: showVote,
        destroyOnClose: true,
        centered: true,
        onCancel: function onCancel() {
          setShowVote(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '40%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(VoteNow, {
          candidat: selectedCandidat
        })
      })
    })]
  });
};
export default ContestCandidatesView;